import { MediaDocument } from './media-document.model';

export enum ContentDocumentMediaType {
    Blog = 'social_blogs',
    Comments = 'social_comments',
    EditorialBlog = 'editorial_blogs',
    Facebook = 'facebook',
    Forums = 'social_message_boards',
    Instagram = 'instagram',
    News = 'news',
    ProductReview = 'social_reviews',
    Radio = 'tveyes_radio',
    Television = 'tveyes_television',
    Twitter = 'twitter',
    Youtube = 'youtube'
}

/**
 * @deprecated use MediaDocument instead
 */
export class ContentDocument extends MediaDocument {
    constructor(originalDoc?: any) {
        super(originalDoc);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/content-document.model.ts